import {
  GetStripeConfigResponse,
  NewPaymentIntentParams,
  PaymentIntent,
} from '@eventmanager/types';
import { Stripe, StripeCardElement } from '@stripe/stripe-js';

import { apiRoutes } from '../../config';
import http from './client';

// [2026-04-25] Retrieves the customer email from a Stripe Checkout session to pre-fill the complete account form.
export async function getCheckoutSession(
  sessionId: string,
): Promise<{ email: string }> {
  const { data } = await http.get(
    `${apiRoutes.billing}/checkout-session?session_id=${encodeURIComponent(
      sessionId,
    )}`,
  );
  return data;
}

export async function getStripeConfig(): Promise<GetStripeConfigResponse> {
  const {
    data: { publishableKey },
  } = await http.get(apiRoutes.billing);

  return publishableKey;
}
export async function newPaymentIntent(
  paymentIntent: NewPaymentIntentParams,
): Promise<PaymentIntent> {
  const response = await http.post(apiRoutes.billing, paymentIntent);
  return response.data;
}

interface IConfirmCardPayment {
  cardElement: StripeCardElement;
  clientSecret: string;
  fullName: string;
  stripe: Stripe;
}
export function confirmCardPayment({
  cardElement,
  clientSecret,
  fullName,
  stripe,
}: IConfirmCardPayment) {
  return stripe.confirmCardPayment(clientSecret, {
    payment_method: {
      card: cardElement,
      billing_details: {
        name: fullName,
      },
    },
  });
}
